import { observable } from 'mobx';
import { singleton } from 'tsyringe';

import { AppParams } from './app-params';

@singleton()
export class AppParametersStore {
  @observable params: AppParams = {} as AppParams;

  get currentDevice() {
    return {
      brandId: this.params?.deviceAttributes.brandId,
      name: this.params?.deviceAttributes.name,
      udid: this.params?.udid,
    };
  }

  get isSmartTv() {
    return this.params?.dmsSetting?.platform === 'CTV';
  }
}
